import axiosTokenInstance from 'services/api/backoffice';
import {
  FAILED_TRANSACTIONS_LIST_IPB,
  FAILED_TRANSACTIONS_LIST_IPB_ERROR,
} from '_models/redux/types';

export const failedTransactionsListIpbAction =
  (page = 1, size = 10, filters = {}) =>
  async (dispatch) => {
    try {
      const params = { page, size, ...filters };

      const response = await axiosTokenInstance.get(`/api/ipb/sims/activation-errors`, {
        params,
        responseType: 'text',
      });

      const fixedText = response.data.replace(
        /"icc_number"\s*:\s*(\d+)/g,
        (_, number) => `"icc_number":"${number}"`,
      );

      const data = JSON.parse(fixedText);

      dispatch({
        type: FAILED_TRANSACTIONS_LIST_IPB,
        payload: data || {},
        status: response.status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: FAILED_TRANSACTIONS_LIST_IPB_ERROR,
        payload: e || {},
      });
    }
  };
